import axios from 'axios';
const BASE_URL = 'http://127.0.0.1:5001/jocksportsdev/us-central1'; 

export const oddsjamApi = axios.create({ 
  baseURL: BASE_URL,
  headers: {
  }

});
axios.interceptors.request.use((config) => {
  config.params = {...config.params}
  return config
})